import React, { useState, useEffect } from "react";
import Select from "react-select";

import gql from "graphql-tag";

import { find as _find } from "lodash";
import { useQuery } from "@apollo/react-hooks";
import { FormGroup, Label } from "reactstrap";

const query = gql`
  query Municipalities($where: MunicipalityWhereInput!) {
    municipalities(where: $where) {
      id
      name
    }
  }
`;

export const MunicipalitySelect = ({
  item,
  provinceId,
  onSelect,
  selectProps = {},
}) => {
  const [values, setValues] = useState([]);
  const [selected, setSelected] = useState({});

  const skip = !provinceId;
  const { data, loading } = useQuery(query, {
    skip,
    variables: {
      where: {
        provinceId,
      },
    },
  });

  useEffect(() => {
    if (!loading && data) {
      setValues(
        (data.municipalities || []).map((value) => ({
          label: value.name,
          value,
        }))
      );
    }
  }, [loading, data]);

  useEffect(() => {
    setSelected(_find(values, ({ value }) => value.id === (item || {}).id));
  }, [item, values]);

  const onChange = (vItem) => {
    setSelected(vItem);
    onSelect(vItem.value);
  };

  return (
    <>
      <FormGroup>
        <Label>Municipio</Label>

        <Select
          classNamePrefix="dhn-select"
          value={selected || null}
          options={values}
          isLoading={loading}
          placeholder="Selecciona un municipio"
          onChange={onChange}
          {...selectProps}
        />
      </FormGroup>
    </>
  );
};
